var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex h-100 align-items-center",attrs:{"id":"404"}},[_vm._v(" Denne siden finnes ikke :( ")])
}
var staticRenderFns = []

export { render, staticRenderFns }